import PageParam from '@/types/page-param';
import Utils from '@/util/utils';
import Client from './client';

const endpoint = '/smileapi/cb';

const getInfoList = (page: PageParam) => {
    return Client.get(`${endpoint}/info/list${Utils.appendQuery(page)}`);
};

const getInfoBrief = () => {
    return Client.get(`${endpoint}/info/brief`);
};

const getInfoDetail = (code: string) => {
    return Client.get(`${endpoint}/info${Utils.appendQuery({code})}`);
};

const updateInfoDetail = (data: any) => {
    return Client.put(`${endpoint}/info`, data);
};

const createInfoDetail = (data: any) => {
    return Client.post(`${endpoint}/info`, data);
};

const updateInfoStar = (data: any) => {
    return Client.post(`${endpoint}/info/star${Utils.appendQuery(data)}`);
};

const getRecommendList = (page: PageParam) => {
    return Client.get(`${endpoint}/recommend/list${Utils.appendQuery(page)}`);
};

const getRecommendDetail = (id: string) => {
    return Client.get(`${endpoint}/recommend${Utils.appendQuery({id})}`);
};

const updateRecommendDetail = (id: string, data: any) => {
    return Client.put(`${endpoint}/recommend${Utils.appendQuery({id})}`, data);
};

const createRecommendBuy = (data: any) => {
    return Client.post(`${endpoint}/recommend/buy`, data);
};

const createRecommendSell = (code: string, data: any) => {
    return Client.post(`${endpoint}/recommend/sell${Utils.appendQuery({code})}`, data);
};

const getRecommendSellable = () => {
    return Client.get(`${endpoint}/recommend/sellable`);
};

const getHoldList = (page: PageParam, filter: any) => {
    return Client.get(`${endpoint}/hold/list${Utils.appendQuery({...page, ...filter})}`);
};

const getFundList = (page: PageParam) => {
    return Client.get(`${endpoint}/fund/list${Utils.appendQuery(page)}`);
};

const getFundDetail = (id: string) => {
    return Client.get(`${endpoint}/fund${Utils.appendQuery({id})}`);
};

const updateFundDetail = (id: string, data: any) => {
    return Client.put(`${endpoint}/fund${Utils.appendQuery({id})}`, data);
};

const createFundDetail = (data: any) => {
    return Client.post(`${endpoint}/fund`, data);
};

const getFundSummary = () => {
    return Client.get(`${endpoint}/fund/summary`);
};

const getHoldDetail = (id: string) => {
    return Client.get(`${endpoint}/hold${Utils.appendQuery({id})}`);
};

const updateHoldDetail = (id: string, data: any) => {
    return Client.put(`${endpoint}/hold${Utils.appendQuery({id})}`, data);
};

const getHoldSellable = () => {
    return Client.get(`${endpoint}/hold/sellable`);
};

const getHoldBought = (code: string) => {
    return Client.get(`${endpoint}/hold/bought${Utils.appendQuery({code})}`);
};

const createHoldBuy = (data: any) => {
    return Client.post(`${endpoint}/hold/buy`, data);
};

const createHoldSell = (code: string, data: any) => {
    return Client.post(`${endpoint}/hold/sell${Utils.appendQuery({code})}`, data);
};

const getReportList = (page: PageParam, filter: any) => {
    return Client.get(`${endpoint}/report/list${Utils.appendQuery({...page, ...filter})}`);
};

const getRecentBuy = (page: PageParam, filter: any) => {
    return Client.get(`${endpoint}/report/recent/buy${Utils.appendQuery({...page, ...filter})}`);
};

export default {
    getInfoList,
    getReportList,
    getInfoBrief,
    getInfoDetail,
    updateInfoDetail,
    createInfoDetail,
    updateInfoStar,
    getRecommendList,
    getRecommendDetail,
    updateRecommendDetail,
    createRecommendBuy,
    getRecommendSellable,
    createRecommendSell,
    getHoldList,
    getFundList,
    getFundDetail,
    updateFundDetail,
    createFundDetail,
    getFundSummary,
    getHoldDetail,
    updateHoldDetail,
    getHoldSellable,
    getHoldBought,
    createHoldBuy,
    createHoldSell,
    getRecentBuy,
};
